import type { FC, ReactNode } from 'react'

import { useEffect, useState } from 'react'
import { siteConfig } from '@/constants/site'

interface LocalTimeProps {
    className?: string
}

/** The studio's current local time. Rendered after mount so server and browser markup always match. */
export const LocalTime: FC<LocalTimeProps> = ({ className }): ReactNode => {
    const [time, setTime] = useState<string | null>(null)

    useEffect(() => {
        const format = new Intl.DateTimeFormat('en-GB', {
            hour: '2-digit',
            minute: '2-digit',
            timeZone: siteConfig.timeZone
        })

        const update = (): void => setTime(format.format(new Date()))

        update()
        const interval = window.setInterval(update, 15000)

        return () => window.clearInterval(interval)
    }, [])

    return (
        <span className={className}>
            {time ?? '--:--'}
        </span>
    )
}
